export enum ThinProfileSort {
  LastName = 'last_name',
}
